import EditIcon from '@mui/icons-material/Edit';
import { ROUTES } from 'constants/routes';
import React from 'react';
import { useNavigate } from 'react-router';
import { titleCase } from 'utilities';
import { isNotDisplayedInVehicleProfile, transformVehicleEntries } from 'utilities/vehicle';

import { VehicleProfileColumn } from 'components';

const formatTireData = (tireData) => {
  if (!tireData) {
    return null;
  }
  const filteredData = Object.entries(tireData).filter(([key, _]) => key !== 'id' && key !== 'vehicleId' && key !== 'createdAt' && key !== 'updatedAt');
  return (
    <div>
      {filteredData.map(([key, value]) => (
        <div key={key} className="d-flex justify-content-between mt-4">
          <span>{titleCase(key.replace(/([A-Z])/g, ' $1'))}</span>
          <span className="fw-bolder">{typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value || '-'}</span>
        </div>
      ))}
    </div>
  );
};

const ProfileColumn = ({ vehicle, className }) => {
  const navigate = useNavigate();
  const vehicleEntries = transformVehicleEntries(vehicle);

  const getValue = (v, index) => {
    if (!isNotDisplayedInVehicleProfile(v)) {
      if (v.key.includes('Tire')) {
        return (
          <div
            key={v.key}
            className={`vehicle-row-gap d-flex justify-content-between flex-column ${index === 0 ? '' : 'mt-4'}`}
            data-testid="vehicle-entry"
          >
            {formatTireData(v.value)}
          </div>
        );
      }

      return (
        <div
          key={v.key}
          className={`vehicle-row-gap d-flex justify-content-between ${index === 0 ? '' : 'mt-4'}`}
          data-testid="vehicle-entry"
        >
          <span>{titleCase(v.key)}</span>
          <span className="fw-bolder">
            {typeof v.value === 'boolean' ? (v.value ? 'Yes' : 'No') : v.value || '-'}
          </span>
        </div>
      );
    }
  };

  const handleEditProfile = () => {
    navigate(ROUTES.MAIN.VEHICLES.EDIT.replace(':id', vehicle.id));
  };

  return (
    <VehicleProfileColumn
      title="Vehicle profile"
      className={className}
      icon={<EditIcon />}
      handleAction={handleEditProfile}
    >
      <div>{vehicleEntries.map((v, index) => getValue(v, index))}</div>
    </VehicleProfileColumn>
  );
};

export default ProfileColumn;
